import SnippingToolPopupContainer from './SnippingToolPopupContainer';

export default SnippingToolPopupContainer;